import { render, staticRenderFns } from "./rList.vue?vue&type=template&id=1bb70dd8&scoped=true"
import script from "./rList.vue?vue&type=script&lang=js"
export * from "./rList.vue?vue&type=script&lang=js"
import style0 from "./rList.vue?vue&type=style&index=0&id=1bb70dd8&prod&scoped=true&lang=css"
import style1 from "./rList.vue?vue&type=style&index=1&id=1bb70dd8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb70dd8",
  null
  
)

export default component.exports